import { create } from './StoreCreator';

const initialState = {
  isHomepageMenuVisible: false,
  isHomepageSubMenuVisible: false,
};

const reducer = (draft, action) => {
  const { payload, type } = action;
  switch (type) {
    case ACTIONS.SET_HOMEPAGE_MENU_VISIBILITY:
      return {
        ...draft,
        isHomepageMenuVisible: payload?.isVisible
      };
    case ACTIONS.SET_HOMEPAGE_SUB_MENU_VISIBILITY:
      return {
        ...draft,
        isHomepageSubMenuVisible: payload?.isVisible
      };
    default:
      return draft;
  }
};

const [
  LayoutProvider,
  useLayoutStore,
  useLayoutDispatch
] = create(reducer, initialState);

const ACTIONS = {
  SET_HOMEPAGE_MENU_VISIBILITY: 'SET_HOMEPAGE_MENU_VISIBILITY',
  SET_HOMEPAGE_SUB_MENU_VISIBILITY: 'SET_HOMEPAGE_SUB_MENU_VISIBILITY',
};

function useLayoutDispatchHelpers() {
  const dispatch = useLayoutDispatch();

  const setHomepageMenuVisibility = (isVisible) => dispatch({
    type: ACTIONS.SET_HOMEPAGE_MENU_VISIBILITY,
    payload: { isVisible }
  });

  const setHomepageSubMenuVisibility = (isVisible) => dispatch({
    type: ACTIONS.SET_HOMEPAGE_SUB_MENU_VISIBILITY,
    payload: { isVisible }
  });

  return {
    setHomepageMenuVisibility,
    setHomepageSubMenuVisibility
  };
}

export {
  LayoutProvider,
  useLayoutStore,
  useLayoutDispatchHelpers,
};
